import { SidebarDrawer } from "@jugl-web/ui-kit";
import { FC, useCallback, useRef } from "react";
import { NewTicketFormValues } from "../../types";
import { CreateTicketSidebarContent } from "./components/CreateTicketSidebarContent";

export type CreateTicketSidebarProps = {
  isOpen: boolean;
  initialFormValues?: Partial<NewTicketFormValues>;
  onClose: () => void;
};

export const CreateTicketSidebar: FC<CreateTicketSidebarProps> = ({
  isOpen,
  initialFormValues,
  onClose,
}) => {
  const customCloseHandlerRef = useRef<(() => void) | null>(null);

  const registerCustomCloseHandler = useCallback(
    (handler: (() => void) | null) => {
      customCloseHandlerRef.current = handler;
    },
    []
  );

  const handleDrawerClose = useCallback(() => {
    if (customCloseHandlerRef.current) {
      customCloseHandlerRef.current();
      return;
    }

    onClose();
  }, [onClose]);

  return (
    <SidebarDrawer
      className="top-1.5 right-1.5 bottom-1.5 flex h-auto w-[calc(100vw-12px)] max-w-[520px] flex-col overflow-hidden rounded-[20px] border border-solid border-dark-100 shadow-[-13px_0_32px_0_rgba(0,0,0,0.12)]"
      isOpen={isOpen}
      hasBackdrop={false}
      onClose={handleDrawerClose}
      customHeader={null}
    >
      <CreateTicketSidebarContent
        initialFormValues={initialFormValues}
        onClose={onClose}
        registerCustomCloseHandler={registerCustomCloseHandler}
      />
    </SidebarDrawer>
  );
};
